define.alias("ember-svg-jar/helpers/svg-jar", "settings/helpers/svg-jar");